import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { requestDTEsAsync, selectData, selectIsLoading } from 'slices/ndeSlice';
import api from '../../_helpers/api';

import { Filters } from 'Components/Common/Filter/Filters';
import { downloadFile, downloadReport } from 'Components/_helpers/utils';
import SectionPanel from 'Components/Common/SectionPanel/SectionPanel';
import SendMailModal from 'Components/Common/SendMail/SendMailModal';
import { CustomTable } from 'Components/Common/Table/CustomTable';
import { CustomPagination, LIMIT } from 'Components/Common/Table/CustomPagination';

export const NDETable = () => {
  const documentsData = useSelector(selectData);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [currFil, setCurrFil] = useState({});
  const [limit, setLimit] = React.useState(LIMIT);
  const [page, setPage] = React.useState(1);
  const [openModalForm, setOpenModalForm] = useState(false);
  const loading = useSelector(selectIsLoading);

  const handleChangeLimit = (dataKey) => {
    setPage(1);
    setLimit(dataKey);
    dispatch(requestDTEsAsync({ pagination: { NumberPage: page, SizePage: dataKey } }));
  };

  const handleChangePage = (val) => {
    setPage(val);
    dispatch(requestDTEsAsync({ ...currFil, pagination: { NumberPage: val, SizePage: limit } }));
  };

  const handleFilter = (params) => {
    setPage(1);
    setCurrFil(params);
    dispatch(requestDTEsAsync(params));
  }


  const handleDownloadReport = () => {
    downloadReport(
      `${api.getUri()}NDE/DTE/Report`,
      `DTE NDE Report.xlsx`,
      currFil
    );    
  };

  const onSelectAction = (eventKey, rowData) => {
    switch (eventKey) {
      case 1:
        downloadFile(
          `${api.getUri()}NDE/Json?codigoGeneracion=${rowData.dte.identificacion.codigoGeneracion}`,
          `${rowData.dte.identificacion.codigoGeneracion}.json`
        );
        break;
      case 2:
        console.log('correo');
        break;
      case 3:
        downloadFile(
          `${api.getUri()}NDE/Zip?codigoGeneracion=${rowData.dte.identificacion.codigoGeneracion}`,
          `${rowData.dte.identificacion.codigoGeneracion}.zip`
        );
        break;
      case 4:
        navigate(`/main/nde/${rowData.dte.identificacion.codigoGeneracion}`);
        break;
      case 5:
        setOpenModalForm(true);
        break;
      default: break;
    }
  };

  useEffect(() => {
    dispatch(requestDTEsAsync({ pagination: { NumberPage: page, SizePage: limit } }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SectionPanel
      title={
        <div className="table__hader">
          <h4>DTE: Nota de Débito Electrónica (NDE)</h4>
        </div>
      }
    >
      <div>
        <SendMailModal isOpen={openModalForm} setOpen={setOpenModalForm} data={{}} />
        <Filters limit={limit} page={page} tipoDte={'NDE'} onFilter={handleFilter} onDownloadData={handleDownloadReport} recordsTotal={documentsData.recordsTotal}/>
        <CustomTable data={documentsData.items} loading={loading} onSelectAction={onSelectAction} />
        <CustomPagination
          totalRecords={documentsData.recordsTotal}
          limit={limit}
          page={page}
          handleChangePage={handleChangePage}
          handleChangeLimit={handleChangeLimit}
        />
      </div>
    </SectionPanel>
  );
};
